import { sendTimeCardsToPayroll } from '@lib/api'
import { timeCardKeys } from '@lib/keys'
import { useQueryClient, useMutation } from '@tanstack/react-query'
import { pollBatchOperation } from '@utils/pollBatchOperationStatus'

export const useSendToPayroll = () => {
  const queryClient = useQueryClient()

  return useMutation(
    async (timeCardIds: number[]) => {
      // sendTimeCardsToPayroll endpoint returns a Batch Operation,
      // which performs all work asynchronously. We must
      // poll the Batch Operation status until it is completed,
      // then we resolve the mutation.
      const { batchOperation } = await sendTimeCardsToPayroll(timeCardIds)
      return pollBatchOperation(batchOperation)
    },
    {
      onSuccess: () => {
        void queryClient.invalidateQueries(timeCardKeys.all)
      },
    },
  )
}
